// Configuración del backend
const BACKEND_PORT = process.env.REACT_APP_BACKEND_PORT || '8000';
const BACKEND_PROTOCOL = process.env.REACT_APP_BACKEND_PROTOCOL || window.location.protocol.replace(':', '') || 'https';

export const getBackendUrl = () => {
  return process.env.REACT_APP_BACKEND_URL || `${BACKEND_PROTOCOL}://${window.location.hostname}:${BACKEND_PORT}`;
};

// Configuración de Axios
export const axiosConfig = {
  baseURL: getBackendUrl(),
  timeout: 600000, // 10 minutos
  headers: {
    'Content-Type': 'application/json',
  }
};

// URLs base
export const API_BASE_URL = getBackendUrl();
export const FILE_BASE_URL = process.env.NODE_ENV === 'production'
  ? 'https://gpa-pacientes-archivos.nyc3.digitaloceanspaces.com'
  : `${API_BASE_URL}/archivos`;

// Configuración de producción
export const isProduction = process.env.NODE_ENV === 'production';
export const isDevelopment = process.env.NODE_ENV === 'development';

// Configuración de debug
export const DEBUG_MODE = isDevelopment || process.env.REACT_APP_DEBUG === 'true';

// Configuración de timeouts
export const TIMEOUTS = {
  SHORT: 30000,    // 30 segundos
  MEDIUM: 120000,  // 2 minutos
  LONG: 600000,    // 10 minutos
  VERY_LONG: 1800000 // 30 minutos
}; 